import { AccountFields, CreateFieldPayload, Field } from './types';
import { HttpClient } from '../http-client';

export class FieldAPIClient extends HttpClient {
  public async getAllFields(): Promise<AccountFields[]> {
    return this.get<AccountFields[]>('/all-fields');
  }
  public async getAllExternalTeamMembersFields(): Promise<AccountFields> {
    return this.get<AccountFields>(
      '/users/fields?objectSubType=EXTERNAL_TEAM_MEMBER',
    ).then((response) => ({
      ...response,
      fields: response.fields.map((field, index) => ({
        ...field,
        fieldIndex: index,
      })),
    }));
  }

  public async createField(payload: CreateFieldPayload): Promise<Field> {
    return this.post('/fields', payload);
  }
  public async updateField(
    fieldId: number,
    payload: CreateFieldPayload,
  ): Promise<Field> {
    return this.put(`/fields/${fieldId}`, payload);
  }
  public async deleteField(fieldId: number) {
    return this.delete(`/fields/${fieldId}`);
  }
}
